"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitWorkflow = void 0;
const context_1 = require("../../../components/ReplaceVTOWorkflow/context");
const react_1 = require("react");
const components_1 = require("../../../components");
const hooks_1 = require("../../../hooks");
const useSubmitWorkflow = ({ associateInfo, setIsShowSummary }) => {
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [status, setStatus] = (0, react_1.useState)();
    const [title, setTitle] = (0, react_1.useState)('Replace with PTO');
    const [supportingText, setSupportingText] = (0, react_1.useState)('');
    const [caseId, setCaseId] = (0, react_1.useState)('');
    const { duration } = (0, context_1.useReplaceVTOWorkflowContext)();
    const { submitTravelTimeState: { loading: submitReplaceVTOLoading, data: submitReplaceVTOData, error: submitReplaceVTOError }, submitTravelTime } = (0, hooks_1.useSubmitTravelTime)(Object.assign(Object.assign({}, associateInfo), { durationOfTravel: duration }));
    (0, react_1.useEffect)(() => {
        setIsSubmitting(submitReplaceVTOLoading);
    }, [submitReplaceVTOLoading]);
    (0, react_1.useEffect)(() => {
        let addTitle = '';
        let addSupportingText = '';
        let status = undefined;
        let addCaseId = '';
        if (submitReplaceVTOData) {
            status = components_1.ToastIconStatus.success;
            addTitle = 'Your Request to replace VTO with PTO is submitted';
            addSupportingText =
                'Your time card will be updated after the request is processed. It may take up to 24 hours for ' +
                    'the Timecards to reflect the updates';
            addCaseId = submitReplaceVTOData.caseId;
        }
        if (submitReplaceVTOError) {
            status = components_1.ToastIconStatus.error;
            addTitle = 'System error';
            addSupportingText =
                "We couldn't process your request for replacing VTO because of a system error. Please try submitting this request again.";
        }
        if (submitReplaceVTOError || submitReplaceVTOData) {
            setStatus(status);
            setTitle(addTitle);
            setSupportingText(addSupportingText);
            setCaseId(addCaseId);
            setIsShowSummary(true);
        }
    }, [isSubmitting, submitReplaceVTOData, submitReplaceVTOError]);
    return {
        setIsSubmitting,
        isSubmitting,
        submitTravelTime,
        status,
        title,
        supportingText,
        caseId
    };
};
exports.useSubmitWorkflow = useSubmitWorkflow;
